import type { Theme } from '@emotion/react';
import { useTheme } from '@emotion/react';
import { useState, useEffect } from 'react';

const parseQuery = (q: string, theme: Theme) => {
  switch (q) {
    case 'lg':
      return `(min-width: ${theme.breakpoints.lg.width}px)`;
    case 'md':
      return `(min-width:${theme.breakpoints.md.width}px) and (max-width: ${
        theme.breakpoints.ipadPro.width - 1
      }px)`;
    case 'sm':
      return `(max-width: ${theme.breakpoints.md.width - 1}px)`;
    case 'print':
      return 'print';
  }
  return q;
};

export function useMedia(rawQuery: string, defaultState = false) {
  const [state, setState] = useState(defaultState);
  const theme = useTheme();
  const query = parseQuery(rawQuery, theme);

  useEffect(() => {
    if (typeof window !== 'undefined') {
      let mounted = true;
      const mql = window.matchMedia(query);

      const onChange = () => {
        if (!mounted) {
          return;
        }

        setState(!!mql.matches);
      };

      mql.addListener(onChange);
      setState(mql.matches);

      return () => {
        mounted = false;
        mql.removeListener(onChange);
      };
    }
  }, [query]);

  return state;
}
